<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="header tac fs18 pt10 pb10" v-if="title">{{ title }}</h3>
      <div class="pl15 tac pr15 pt20 pb20 fs14">
        <img :src="icon" alt="" width="90">
        <p class="text mt10 fs16">绑定成功，您的病案号是</p>
        <p class="code mt10 fs20 ml60 mr60 pt10 pb10">{{ code }}</p>
      </div>
      <div class="footer pl15 pr15 pb15 pt15">
        <van-button type="info" class="mb10" block round @click="onClick('confirm')">
          知道了
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {DIALOG_ICONS} from "@/plugins/dialog/config";

export default {
  name: "yygh-bind-success",
  components: {},
  data() {
    return {
      code: "",
      title: "",
      icon: DIALOG_ICONS.SUCCESS,
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
.text {
  font-weight: bolder;
}

.code {
  color: #F96A0E;
  background: #FEFCED;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/yygh-bind-success.vue